import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getDatabase } from '../../data/localDataStore';

const SharedFile = () => {
  const { fileId } = useParams();

  const fileRecord = useMemo(() => {
    const database = getDatabase();
    return database.generatedFiles.find((file) => file.id === fileId) || null;
  }, [fileId]);

  useEffect(() => {
    if (!fileRecord?.content) {
      return undefined;
    }

    window.location.replace(fileRecord.content);
    return undefined;
  }, [fileRecord]);

  if (!fileRecord) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
        <div className="max-w-md rounded-2xl bg-white p-8 text-center shadow-sm border border-slate-200">
          <h1 className="text-xl font-semibold text-slate-900 mb-3">File non trovato</h1>
          <p className="text-sm text-slate-600">
            Il link richiesto non corrisponde a nessun file disponibile nel salvataggio locale.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="max-w-md rounded-2xl bg-white p-8 text-center shadow-sm border border-slate-200">
        <h1 className="text-xl font-semibold text-slate-900 mb-3">Apertura file</h1>
        <p className="text-sm text-slate-600">
          Se il file non si apre automaticamente, usa questo link diretto:
        </p>
        <a
          href={fileRecord.content}
          className="mt-4 inline-flex rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Apri {fileRecord.name}
        </a>
      </div>
    </div>
  );
};

export default SharedFile;
